import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticatedUser } from '~core/models';
import { NavigationService, StorageService } from '~core/services';

/**
 * Content for the customer search sidebar.
 */
@UntilDestroy()
@Component({
  selector: 'app-user-profile-sidebar',
  template: `
  <nav class="esf-app-menu esf-accordion">
    <div class="esf-app-menu__unit">
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.crmHome'
          [routerLink]="homeLink">CRM Home</a>
      </div>
    </div>
  </nav>
  `
})
export class UserProfileSidebarComponent implements OnDestroy {
  public authenticatedUser: AuthenticatedUser;
  public currentPage: string;
  public homeLink: string = '/manage/clubs';

  constructor(public storage: StorageService, public route: ActivatedRoute, public navigationService: NavigationService) {
    this.storage.authenticatedUser
      .pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => this.authenticatedUser = user);
    this.navigationService.castCurrentPage
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentPage = data);
  }

  public ngOnDestroy(): void { }
}
